import React, { Component } from "react";
import {
  FormGroup,
  FormControl,
  Button,
  Pagination,
  InputGroup,
  Glyphicon,
  Form,
  Thumbnail
} from "react-bootstrap";
import "./AddBook.css";
import BookSearchResult from "../components/BookSearchResult";
import { API } from "aws-amplify";
import Quagga from "quagga"; // ES6
import Modal from "react-modal";
import Rater from "react-rater";
import { toast } from "react-toastify";

export default class AddBook extends Component {
  constructor(props) {
    super(props);
    this.props.currentPage = 1;
    this.state = {
      isLoading: null,
      searchText: "",
      results: null,
      nextResultSet: 0,
      url: null,
      currentPage: 1,
      openBookDetails: false,
      bookDetails: null,
      searchType: ""
    };
    this.foundBarcode = this.foundBarcode.bind(this);
    this.processBarcode = this.processBarcode.bind(this);
    this.openBookPopup = this.openBookPopup.bind(this);
    this.closeBookPopup = this.closeBookPopup.bind(this);
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) this.props.history.push("/login");

    this.setState({
      isLoading: false
    });
  }

  handleChange = event => {
    event.preventDefault();
    this.setState({
      searchText: event.target.value
    });
  };

  openBookPopup(book) {
    console.log("Popup Book: ", book);
    var bookDetail = { Info: book };
    this.setState({
      bookDetails: bookDetail,
      openBookDetails: true,
      addMessage: ""
    });
    console.log("popup detail", this.state.bookDetails);
  }
  closeBookPopup() {
    console.log("closeBookPopup", this.state.openBookDetails);

    this.setState({ openBookDetails: false });

    console.log("openBookDetails", this.state.openBookDetails);
    return true;
  }
  readBarCode = async event => {
    console.log("readBarCode start");
    var imgViewport = document.getElementById("barcode");
    if (imgViewport != null) {
      imgViewport.style.display = "";
      imgViewport.innerHTML = "";
    }

    //const Quagga = require('quagga').default; // Common JS (important: default)
    var self = this;
    Quagga.init(
      {
        numOfWorkers: 0,
        frequency: 5,
        inputStream: {
          type: "LiveStream",
          target: document.querySelector("#barcode"), // Or '#yourElement' (optional)
          constraints: {
            width: { min: 320 },
            height: { min: 240 },
            facingMode: "environment",
            aspectRatio: { min: 1, max: 2 }
          }
        },

        decoder: {
          readers: [
            "code_128_reader",
            "ean_reader",
            "ean_8_reader",
            "code_39_reader",
            "code_39_vin_reader",
            "codabar_reader",
            "upc_reader",
            "upc_e_reader",
            "i2of5_reader"
          ],
          debug: {
            showCanvas: true,
            showPatches: true,
            showFoundPatches: true,
            showSkeleton: true,
            showLabels: true,
            showPatchLabels: true,
            showRemainingPatchLabels: true,
            boxFromPatches: {
              showTransformed: true,
              showTransformedBox: true,
              showBB: true
            }
          }
        },
        locate: true,
        locator: {
          halfSample: true,
          patchSize: "medium",
          debug: {
            showCanvas: false,
            showPatches: false,
            showFoundPatches: false,
            showSkeleton: false,
            showLabels: false,
            showPatchLabels: false,
            showRemainingPatchLabels: false,
            boxFromPatches: {
              showTransformed: false,
              showTransformedBox: false,
              showBB: false
            }
          }
        },
        debug: {
          drawBoundingBox: true,
          showFrequency: true,
          drawScanline: true,
          showPattern: true
        }
      },
      function(err) {
        if (err) {
          console.log("Initialization finished with error:", err.message);
          var imgViewport = document.getElementById("barcode");
          if (imgViewport != null) {
            imgViewport.style.display = "none";
          }
          toast.error("Error initializing camera: " + err.message);
          return;
        }
        console.log("Initialization finished. Ready to start");
        Quagga.onDetected(self.foundBarcode);
        Quagga.onProcessed(self.processBarcode);

        Quagga.start();
        console.log("Quagga started");

        setTimeout(() => {
          console.log("Quagga timeout");
          self.foundBarcode(null);
        }, 10000);
        console.log("Quagga init done");
      }
    );
  };
  foundBarcode = async result => {
    console.log("foundBarcode start", result);
    Quagga.stop();
    var imgViewport = document.getElementById("barcode");
    if (imgViewport != null) imgViewport.style.display = "none";

    if (result != null) {
      console.log("foundBarcode code found:", result.codeResult);
      this.setState({
        searchText: result.codeResult.code,
        searchType: "isbn="
      });
      this.searchBook();
    }
  };
  processBarcode = async result => {
    console.log("ProcessBarcode", result);
  };

  searchBook = async event => {
    if (event) event.preventDefault();
    if (this.state.searchText.length > 0) {
      this.setState({
        isLoading: true,
        results: null,
        currentPage: 1
      });
      let books = null;
      try {
        books = await this.searchBooks();
        console.log("searchbook results:", books);
      } catch (e) {
        alert(e);
      }

      this.setState({
        results: books,
        isLoading: false,
        searchType: ""
      });
    }
    return false;
  };

  handleLogin = async event => {
    this.props.history.push("/login");
  };
  openLibrary = async event => {
    this.props.history.push("/library");
  };
  getRemoteData = async event => {
    console.log("GetRemoteData: ", event);
    var url = event;

    return new Promise((resolve, reject) => {
      const client = url.startsWith("https")
        ? require("https")
        : require("http");
      const request = client.get(url, response => {
        if (response.statusCode < 200 || response.statusCode > 299) {
          reject(new Error("Failed with status code: " + response.statusCode));
        }
        const body = [];
        response.on("data", chunk => body.push(chunk));
        response.on("end", () => resolve(body.join("")));
      });
      request.on("error", err => reject(err));
    });
  };

  popUpBook = function(data) {
    console.log("Add Book: ", data);
    API.post("books", "book/addsearch", {
      ISBN: data.volumeInfo.industryIdentifiers[0].identifier,
      Info: data,
      Title: data.volumeInfo.title
    }).then(response => {
      console.log("response: ", response);
    });
    return;
  };

  searchPage = event => {
    console.log("searchPage number?:", isNaN(event.target.id));
    if (isNaN(event.target.id)) return;
    console.log("searchPage:", event.target.id);
    debugger;
    this.setState({ currentPage: parseInt(event.target.id, 10) }, () => {
      this.searchBook(event);
    });
    this.searchBox.scrollIntoView({ behavior: "smooth" });

    return;
  };

  shouldComponentUpdate(nextProps, nextState) {
    console.log("popup detail", this.state.bookDetails);
    if (this.state.currentPage !== nextState.currentPage) {
      console.log("shouldComponentUpdate", false);
      return false;
    }
    console.log("shouldComponentUpdate", true);
    return true;
  }
  searchBooks = async event => {
    console.log("Obtaining books.", this.state.currentPage);
    var result = null;
    // AWS
    /*
		await API.post("books", "books/search", { body: { 'searchText': this.state.searchText, 'startIndex': (this.state.currentPage - 1) * 10 } }).then((response) => {
			console.log("Response from Google:", response);
			result = JSON.parse(response.body);
			console.log("AWS API response:", result);
			//return result;
		});
*/
    //GOOGLE

    var url =
      "https://www.googleapis.com/books/v1/volumes?key=AIzaSyCNUQpCzEX7_ZtUpby0_UEj1IgJHse06M0&maxResults=40&q=" +
      this.state.searchType +
      this.state.searchText +
      "&startIndex=0";

    const storedBooks = JSON.parse(sessionStorage.getItem(url));
    if (storedBooks) {
      console.log("Books from Cache:", storedBooks);
      result = storedBooks;
    } else {
      console.log("Books not found in Cache.");

      await this.getRemoteData(url).then(response => {
        //console.log("Response from Google:" + response);
        result = JSON.parse(response);

        console.log("Google API response:", result);
        sessionStorage.setItem(url, response);
        //return result;
      });
    }

    let localLibrary = localStorage.getItem("personalLibrary");
    if (localLibrary !== null) {
      let jsonLibrary = JSON.parse(localLibrary);
      for (let k = 0; k < result.items.length; k++) {
        if (result.items[k].volumeInfo.industryIdentifiers) {
          let isbn =
            result.items[k].volumeInfo.industryIdentifiers[0].identifier;

          for (let l = 0; l < jsonLibrary.Items.length; l++) {
            console.log("Comparing:", isbn, jsonLibrary.Items[l].ISBN);
            if (isbn === jsonLibrary.Items[l].ISBN) {
              result.items[k].owned = true;
              console.log("Found:", isbn);
              break;
            } else result.items[k].owned = false;
          }
        }
      }
    }

    console.log("Books result", result);
    return result;
  };

  addBook = function(data) {
    console.log("Add Book: ", data);
    API.post("books", "user/book", {
      body: {
        ISBN: data.volumeInfo.industryIdentifiers[0].identifier,
        Info: data,
        Title: data.volumeInfo.title
      }
    }).then(response => {
      console.log("response: ", response);
      this.setState({ addMessage: "Book added succesfully" });
      setTimeout(
        function() {
          this.closeBookPopup();
        }.bind(this),
        3000
      );
    });

    return;
  };
  render() {
    console.log("book state", this.state.bookDetails);
    console.log("book open", this.state.openBookDetails);
    const books = this.state.results;
    console.log("Books render page:", this.state.currentPage);
    let list_area;
    if (books) {
      let pages = [];
      //var totalPages = Math.floor(books.totalItems / 10);
      let totalPages =
        books.totalItems > 50 ? 5 : Math.floor(books.totalItems / 10);
      //var minPage = this.state.currentPage > 7 ? this.state.currentPage - 4 : 1;
      let minPage = 1;
      //var maxPage = (this.state.currentPage + 7) < totalPages ? this.state.currentPage + 7 : totalPages;
      let maxPage = totalPages;
      console.log(
        "Pagination",
        totalPages,
        minPage,
        maxPage,
        this.state.currentPage
      );
      //pages.push(<Pagination.First key={1} id={1} onClick={this.searchPage} disabled={this.state.currentPage === 1} />);
      //pages.push(<Pagination.Prev key={this.state.currentPage - 1} id={this.state.currentPage - 1} onClick={this.searchPage} disabled={this.state.currentPage === 1} />);
      //if (this.state.currentPage > 7)
      //	pages.push(<Pagination.Ellipsis id={1} onClick={this.searchPage} disabled={this.state.currentPage === 1} />);

      //let pageNumber = minPage;
      for (
        let pageNumberTmp = minPage;
        pageNumberTmp <= minPage + 9 && pageNumberTmp < maxPage;
        pageNumberTmp++
      ) {
        //				console.log("ActivePage:",pageNumberTmp,this.state.currentPage,pageNumberTmp === this.state.currentPage);
        debugger;
        pages.push(
          <Pagination.Item
            key={"page" + pageNumberTmp}
            id={pageNumberTmp}
            onClick={this.searchPage}
            active={pageNumberTmp === this.state.currentPage}
          >
            {pageNumberTmp}
          </Pagination.Item>
        );
        //pageNumber++;
      }
      // if ((pageNumber + 5) < totalPages) {
      // 	pages.push(<Pagination.Ellipsis id={pageNumber + 9} onClick={this.searchPage} />);
      // }
      // pages.push(<Pagination.Next key={pageNumber + 1} id={pageNumber + 1} onClick={this.searchPage} />);
      // pages.push(<Pagination.Last key={totalPages} id={totalPages} onClick={this.searchPage} />);

      if (books.items)
        list_area = (
          <ul className="list-group">
            {" "}
            {books.items.map((Item, i) => {
              //console.log("Rendering book search result", Item)
              if (Item.volumeInfo.industryIdentifiers)
                return (
                  <BookSearchResult
                    key={i}
                    src={Item}
                    onClick={() => {
                      this.openBookPopup(Item);
                    }}
                  />
                );
              else return "";
            })}
            <li className="list-group-item text-primary" key="0">
              <Pagination>{pages}</Pagination>
            </li>
          </ul>
        );
      else
        list_area = (
          <div>
            {" "}
            BOOKS NOT FOUND<br></br>
            <li className="list-group-item text-primary" key="0">
              <Pagination>{pages}</Pagination>
            </li>
          </div>
        );
    }

    return (
      <div className="AddBook">
        <div
          id="barcode"
          className="viewport"
          ref={searchBox => {
            this.searchBox = searchBox;
          }}
        ></div>
        <Form onSubmit={this.searchBook}>
          <FormGroup>
            <InputGroup>
              <FormControl
                autoFocus
                type="text"
                value={this.state.searchText}
                onChange={this.handleChange}
                placeholder="Title, Author, Genre, ISBN..."
              />
              <InputGroup.Button>
                <Button title="Search Text" onClick={this.searchBook}>
                  <Glyphicon glyph="search" />
                </Button>

                <Button
                  disabled={false}
                  title="Barcode search unavailable"
                  onClick={this.readBarCode}
                >
                  <Glyphicon glyph="barcode" />
                </Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>

          <div> {list_area}</div>
          <div>
            <Modal
              //isOpen={this.state.openBookDetails && this.state.bookDetails != null}
              isOpen={this.state.openBookDetails}
              //onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeBookPopup}
              shouldCloseOnOverlayClick={false}
              shouldCloseOnEsc={false}
              className="Modal text-primary list-group-item"
              //overlayClassName="Overlay"

              //style={customStyles}
              contentLabel="Book Details"
            >
              <Glyphicon
                glyph="remove-circle"
                className="btn btn-lg pull-right floating"
                onClick={this.closeBookPopup}
              />

              {this.state.bookDetails != null ? (
                <span>
                  <h2>{this.state.bookDetails.Info.volumeInfo.title}</h2>

                  {this.state.bookDetails.Info.volumeInfo ? (
                    <div className="bookDetails">
                      {this.state.bookDetails.Info.owned ? (
                        <Button
                          className="pull-right floating"
                          bsStyle="primary"
                        >
                          OWNED
                        </Button>
                      ) : (
                        <Button
                          className="pull-right floating"
                          bsStyle="primary"
                          onClick={() => {
                            return this.addBook(this.state.bookDetails.Info);
                          }}
                        >
                          ADD TO COLLECTION
                        </Button>
                      )}
                      {this.state.bookDetails.Info.volumeInfo.authors ? (
                        this.state.bookDetails.Info.volumeInfo.authors.map(
                          (auth, a) => {
                            return <span>{auth} - </span>;
                          }
                        )
                      ) : (
                        <span>Author unknown</span>
                      )}

                      <Thumbnail
                        src={
                          this.state.bookDetails.Info.volumeInfo &&
                          this.state.bookDetails.Info.volumeInfo.imageLinks
                            ? this.state.bookDetails.Info.volumeInfo.imageLinks
                                .smallThumbnail || "/img/nocover.png"
                            : "/img/nocover.png"
                        }
                        alt={this.state.bookDetails.Title}
                        className="img-rounded img-responsive pull-left"
                      >
                        <Rater
                          rating={
                            this.state.bookDetails.Info.volumeInfo.averageRating
                          }
                          interactive={false}
                        />
                      </Thumbnail>

                      {this.state.bookDetails.Info ? (
                        this.state.bookDetails.Info.volumeInfo ? (
                          <h5>
                            {this.state.bookDetails.Info.volumeInfo.subtitle}
                          </h5>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                      {this.state.bookDetails.Info
                        ? this.state.bookDetails.Info.volumeInfo
                          ? this.state.bookDetails.Info.volumeInfo.description
                          : "No Description Available"
                        : "No Description Available"}
                    </div>
                  ) : (
                    "Book Information Not Available"
                  )}
                  <div className="bookfooter pull-right">
                    {this.state.addMessage}
                  </div>
                </span>
              ) : (
                "Book Information Not Available"
              )}
            </Modal>
          </div>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/AddBook.js